import { inject, Injectable } from '@angular/core';

import { NAVIGATOR } from '@hglobal/common';

import { ToastI18nService } from '../toast-i18n.service';

@Injectable({ providedIn: 'root' })
export class ClipboardService {
  readonly #navigator = inject(NAVIGATOR);
  readonly #toastService = inject(ToastI18nService);

  copy(text: string, messageKey: string): void {
    this.#navigator.clipboard.writeText(text)
      .then(() => {
        this.#toastService.showSuccess(messageKey);
      });
  }
}
